export class ConditionRequirement {
  constructor(action, documentCode, dutyExpression, requirement) {
    this.action = action;
    this.documentCode = documentCode;
    this.dutyExpression = dutyExpression;
    this.requirement = requirement;
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new ConditionRequirement(input.action, input.document_code, input.duty_expression, input.requirement)
    }
    return new ConditionRequirement();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => ConditionRequirement.fromApiObject(item));
    }
    if (input && typeof (input) === "object") {
      return [ConditionRequirement.fromApiObject(input)];
    }
    return [];
  }

  genHtml() {
    
  }
}